export const homeHeroMarkup = String.raw`<!-- ====== HOME VIEW ====== -->
    <div class="view active" id="view-home" data-auth="pending" data-plan="free">
      <section class="home-auth-skeleton" id="homeAuthSkeleton" aria-label="Loading your home workspace">
        <div class="home-auth-skeleton-main">
          <div class="home-skeleton-line home-skeleton-kicker"></div>
          <div class="home-skeleton-line home-skeleton-title"></div>
          <div class="home-skeleton-line home-skeleton-copy"></div>
          <div class="home-skeleton-line home-skeleton-copy short"></div>
        </div>
        <div class="home-auth-skeleton-side">
          <div class="home-skeleton-card"></div>
          <div class="home-skeleton-card"></div>
          <div class="home-skeleton-card"></div>
        </div>
      </section>
      <!-- Guest hero -->
      

      `;
